import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/me_example.jpg'


const _hoisted_1 = {
  key: 0,
  class: "appmain"
}
const _hoisted_2 = {
  key: 1,
  class: "appmain appmain-administration"
}
const _hoisted_3 = { class: "timi-admin-view" }
const _hoisted_4 = { class: "timi-admin-content" }
const _hoisted_5 = { class: "view-title" }
const _hoisted_6 = {
  key: 2,
  class: "appmain"
}
const _hoisted_7 = {
  key: 3,
  class: "appmain appmain--workspace"
}
const _hoisted_8 = {
  key: 4,
  class: "appmain"
}
const _hoisted_9 = { class: "timi-header-nav" }
const _hoisted_10 = { class: "profile-image-rd" }
const _hoisted_11 = {
  key: 0,
  src: _imports_0
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "timi-bottom-nav__mobile" }
const _hoisted_14 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimiHeader = _resolveComponent("TimiHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_AdminHeader = _resolveComponent("AdminHeader")!
  const _component_WorkspaceHeader = _resolveComponent("WorkspaceHeader")!
  const _component_WorkspaceFooter = _resolveComponent("WorkspaceFooter")!
  const _component_TrackingViewNav = _resolveComponent("TrackingViewNav")!
  const _component_DefaultHeader = _resolveComponent("DefaultHeader")!

  return (_ctx.checkLayout=='login')
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_TimiHeader),
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.key,
          class: "timi-login-view"
        }))
      ]))
    : (_ctx.sessionUser.uid && _ctx.checkLayout=='admin')
      ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _createVNode(_component_Sidebar),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AdminHeader, { onHandleLogoutUser: _ctx.logoutUser }, null, 8, ["onHandleLogoutUser"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.adminRouteName), 1)
              ]),
              (_openBlock(), _createBlock(_component_router_view, { key: _ctx.key }))
            ])
          ])
        ]))
      : (_ctx.checkLayout=='timeentryform')
        ? (_openBlock(), _createElementBlock("main", _hoisted_6, [
            (_openBlock(), _createBlock(_component_router_view, { key: _ctx.key }))
          ]))
        : (_ctx.checkLayout=='workspace')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_WorkspaceHeader, {
                sessionUser: _ctx.sessionUser,
                sessionEmployee: _ctx.sessionEmployee,
                workstation: _ctx.localWorkstation
              }, null, 8, ["sessionUser", "sessionEmployee", "workstation"]),
              (_openBlock(), _createBlock(_component_router_view, { key: _ctx.key })),
              false
                ? (_openBlock(), _createBlock(_component_WorkspaceFooter, { key: 0 }))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.sessionUser.uid)
            ? (_openBlock(), _createElementBlock("main", _hoisted_8, [
                _createVNode(_component_DefaultHeader, { onHandleLogoutUser: _ctx.logoutUser }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        false
                          ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, _toDisplayString(_ctx.employeeInitials), 1)
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.getHeaderTitle(_ctx.key)), 1),
                      _createElementVNode("i", {
                        class: "svgicon timi-icon",
                        innerHTML: _ctx.store.getters.svgIcons.timi
                      }, null, 8, _hoisted_12),
                      _createVNode(_component_TrackingViewNav, { activeView: _ctx.key }, null, 8, ["activeView"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onHandleLogoutUser"]),
                (_openBlock(), _createBlock(_component_router_view, {
                  key: _ctx.key,
                  class: "timi-default-view"
                })),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_TrackingViewNav, {
                    showAddIcon: _ctx.checkIsTimeEntryForm,
                    activeView: _ctx.key
                  }, null, 8, ["showAddIcon", "activeView"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("main", _hoisted_14, " Loading... "))
}